import { createClass as _createClass, slicedToArray as _slicedToArray, classCallCheck as _classCallCheck } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable unicorn/filename-case */

/** A convenient store for DOM Measurements that encapsulates clearing all caches at once. */
var CachedDOMMeasurements = /*#__PURE__*/function () {
  function CachedDOMMeasurements(measurements) {
    _classCallCheck(this, CachedDOMMeasurements);

    this.measurements = measurements;
  }

  _createClass(CachedDOMMeasurements, [{
    key: "clearOne",
    value: function clearOne(name) {
      this.measurements[name].clear();
    }
  }, {
    key: "get",
    value: function get(m) {
      return this.measurements[m].value;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;

      Object.keys(this.measurements).forEach(function (m) {
        return _this.clearOne(m);
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return Object.entries(this.measurements).reduce(function (result, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            cachedValue = _ref2[1];

        result[name] = cachedValue.value;
        return result;
      }, {});
    }
  }]);

  return CachedDOMMeasurements;
}();

export { CachedDOMMeasurements };
